import React, { useLayoutEffect } from "react";
import { IntlProvider } from "react-intl";

import { useAppDispatch } from "@hooks/use-store";
import {
  setKeyboardLayout,
  setLocale,
  setSpeedRatio,
  setUnAuthFirstString,
} from "@store/app/app.slice";
import { LOCALE_WITH_SIGNS_PER_MINUTE } from "@constants/global.constants";
import { Locales } from "@typings/global.types";

import { AppRoutes } from "./routes/routes";
import messages from "./translations/messages";

const LOCALE = Locales[window.reactApp.locale];
const LOCALE_MESSAGES = messages[Locales[window.reactApp.locale]];
const KEYBOARD_LAYOUT = window.reactApp.keyboardLayout;

function App() {
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    dispatch(setLocale(LOCALE));
    if (LOCALE_WITH_SIGNS_PER_MINUTE.includes(window.reactApp.locale))
      dispatch(setSpeedRatio(1));

    dispatch(setKeyboardLayout(KEYBOARD_LAYOUT));
    dispatch(setUnAuthFirstString(window.reactApp.firstString));
  }, [dispatch]);

  // при space щоб не пролистувалася сторінка вниз
  window.onkeydown = (e) => {
    return e.keyCode !== 32;
  };

  return (
    <IntlProvider messages={LOCALE_MESSAGES} locale={LOCALE}>
      <div className='mx-auto mt-6 min-h-screen overflow-hidden px-4 pt-3 text-base-xs md:px-6 md:pt-2 md:text-base lg:relative lg:min-h-[890px]'>
        <AppRoutes />
      </div>
    </IntlProvider>
  );
}

export default App;
